/**
 *
 * @param {*} data 单条数据。 返回 对象link。
 * 根据data里type类型，重新返回跳转客户端内的数据(特定type, idOrUrl 属性) 对象link（object）
 * http://know.ifengidc.com/pages/viewpage.action?pageId=15499640#app-switcher
 */
const GETLINKTYPE = data => {
    try {
        if (!Object.prototype.toString.call(data)) {
            return {};
        }

        const _linkDatas = {
            type: data.type,
            idOrUrl: '',
        };

        if (_linkDatas.type === 'web') {
            _linkDatas.type = data.type;
            _linkDatas.idOrUrl = data.url;
        } else if (_linkDatas.type === 'topic2') {
            _linkDatas.type = data.type;
            _linkDatas.idOrUrl = `https://api.iclient.ifeng.com/TopicApiForCmpp?topicid=${data.topicid}`;
        } else if (_linkDatas.type === 'doc' || _linkDatas.type === 'article') {
            _linkDatas.type = 'doc';
            _linkDatas.idOrUrl = `ucms_${data.base62Id}`;
        } else if (_linkDatas.type === 'video' || _linkDatas.type === 'phvideo') {
            _linkDatas.type = 'phvideo';
            _linkDatas.idOrUrl = data.guid;
        } else if (_linkDatas.type === 'videoshortimg') {
            // 其他需要guid的类型
            _linkDatas.type = data.type;
            _linkDatas.idOrUrl = data.guid;
        } else {
            // 其他需要ucms_base62Id的类型
            _linkDatas.type = data.type;
            _linkDatas.idOrUrl = `ucms_${data.base62Id}`;
        }

        return _linkDatas;
    } catch (e) {
        console.error(e);
    }
};

module.exports = {
    GETLINKTYPE,
};
